import { render, staticRenderFns } from "./DashboardDateWidget.vue?vue&type=template&id=17b36602"
import script from "./DashboardDateWidget.vue?vue&type=script&lang=js"
export * from "./DashboardDateWidget.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('17b36602')) {
      api.createRecord('17b36602', component.options)
    } else {
      api.reload('17b36602', component.options)
    }
    module.hot.accept("./DashboardDateWidget.vue?vue&type=template&id=17b36602", function () {
      api.rerender('17b36602', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/view/pages/dashboard_widgets/DashboardDateWidget.vue"
export default component.exports